import { useEffect, useState, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Route, Link, useSearchParams } from 'react-router-dom';
// import auth from '../../api/auth';
// Components
import auth from '../../api/auth'
import { TextInput } from 'carbon-components-react';
import Button from '../../components/Button/Button';
import ResetPassword from './ResetPassword';
import { getSSOURL } from '../../api/auth-api';
const Login = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const history = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false)
  const {client} = useParams()
  const [searchParams] = useSearchParams()
  const [ssoUrls, setSsoUrls] = useState([])
  const saml = useMemo(() => {
    return searchParams.get("saml")
  }, [searchParams])

  useEffect(() => {
    if (saml === "true") {
      console.log('REACHED SAML')
      auth.checkToken((isAuthenticated, usertype) => {
        if (isAuthenticated) {
          props.setAuth(true);
          console.log('reached here')
          // setUsertype(usertype);
        }
        else {
          props.setAuth(false);
          // setUsertype(null);
        }
      })
      // props.setAuth(true)
      // props.setUsertype(currUser.usertype)
      // const token = getCookie("Token")
      // setTokens()
      // const access = getCookie("access")
      // const refresh = getCookie("refresh")
      // setTokens({ access, refresh })
      // history()
      // navigateToNextUrl({ isSso: true })
      // if (access && refresh && isExpired(access) === false && isExpired(refresh) === false) {
      //   navigateToNextUrl({ isSso: true })
      // }
    } 
    // else {
    //   const isAuth = isUserAuthenticated()
    //   if (pathname.includes("login") && isAuth) {
    //     navigateToNextUrl()
    //   }
    // }
    // setIsPageLoading(false)
  }, [saml])

  useEffect(() => {
    if (props.isAuth) {
      history(`/${client}`)
    }

  }, [])

  useEffect(() => {
    getSSOURL().then(res => {
      console.log(res, 'here')
      setSsoUrls(res)
    })
  }, [])

  const onLogin = () => {
    let credentials = { email, password }
    setIsProcessing(true)
    auth.login(credentials, (currUser) => {
      props.setAuth(true)
      props.setUsertype(currUser.usertype)
      // props.setUser(currUser)
      const origin = window.location.origin
      const referrer = document.referrer
      const refPath = referrer.split(origin)[1]
      let path = `/${client}`
      // if (refPath && refPath.replace('/', '') !== 'login') {
      //   path = refPath
      // }
      localStorage.setItem('username', currUser.userName)
      localStorage.setItem('client', client)

      history(path)
    })
  setIsProcessing(false)
  }

  const onKeyEnter = (e) => {
    if(e.keyCode === 13) {
      onLogin()
    }
  }

  return (
    <Container>
      <InputContainer onKeyDown={onKeyEnter}>

      { (ssoUrls && ssoUrls.length > 0 ) &&
      <div className="pb-3">
      {ssoUrls.map((element) => {
        return(
          <a
          href={element?.url}
        >
                <Button
            style={{ width: "100%", marginTop:10 }}
            >
            {element?.button_text}
          </Button>
        </a>
        )
      })}

      </div>

      }
        <i
          style={{ fontSize: 70, marginBottom: 16, color: "#d4d4d4" }}
          className="fal fa-user-circle"/>
        <PrimaryText>Sign in to your account</PrimaryText>
        <SecondaryText>Enter your credential below</SecondaryText>
        <TextInputContainer>
          <TextInput
            id="login-email"
            labelText="Email"
            // placeholder="Enter Email"
            onChange={e => setEmail(e.target.value)}
            />
          </TextInputContainer>
        <TextInputContainer>
          <TextInput.PasswordInput
            id="login-password"
            labelText="Password"
            // placeholder="Enter Password"
            onChange={e => setPassword(e.target.value)}
            />
        </TextInputContainer>
        <Button
          style={{ width: "100%", marginTop:10 }}
          onClick={onLogin} disabled={isProcessing}>
          Sign in
          <i
            style={{ marginLeft: 8, marginTop: 3 }}
            className="fal fa-arrow-circle-right"/>
        </Button>
        {/* <ForgotPasswordContainer>
          <Link to="/reset-password">Forgot Password</Link>
        </ForgotPasswordContainer> */}
      </InputContainer>
      <SecondaryText>2022 &copy; Xogene Services LLC</SecondaryText>
    </Container>
  );
};


export default Login;

export const Container = styled.div`
  padding: 20px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

export const InputContainer = styled.div`
  width: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  padding: 30px;
  margin-top: 50px;
`

export const TextInputContainer = styled.div`
  width: 100%;
  margin-bottom: 12px;
`

export const PrimaryText = styled.div`
  font-size: 17px;
  text-align: center;
  margin-bottom: 6px;
`

export const SecondaryText = styled.div`
  font-weight: 400;
  line-height: 1;
  color: #999;
  text-align: center;
  margin-bottom: 16px;
`
const ForgotPasswordContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`
